/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.25"
        height="94.3"
        viewBox="0 0 82.25 94.3"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M81 58.12v4H1.25v-4ZM81 72.17v7H1.25v-7Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="m56.04 3.73 2.34.88c-6.27 16.74-28 16.26-34.32.48l-.19-.48 2.34-.88c5.23 14 24 14.69 29.66.44Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M23.96 0h-9.64a1.25 1.25 0 0 0-1.25 1.25v26.58a17 17 0 0 1-3.17 9.92l-8 11.07a10 10 0 0 0-1.86 5.81v33.8A5.77 5.77 0 0 0 5.7 94.3h30.84a5.77 5.77 0 0 0 5.66-5.87v-40.9a6 6 0 0 0-.39-2.13L25.17.81A1.24 1.24 0 0 0 23.96 0ZM15.5 2.5h7.56L39.5 46.27a3.6 3.6 0 0 1 .23 1.26v40.9a3.27 3.27 0 0 1-3.17 3.37H5.66a3.27 3.27 0 0 1-3.16-3.37V54.65a7.43 7.43 0 0 1 1.39-4.34l8-11.08.26-.37a19.43 19.43 0 0 0 3.39-11Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M67.97 0h-9.65a1.24 1.24 0 0 0-1.17.81L40.53 45.4a6.17 6.17 0 0 0-.38 2.13v40.9a5.76 5.76 0 0 0 5.65 5.87h30.83a5.76 5.76 0 0 0 5.65-5.87V54.65a9.93 9.93 0 0 0-1.86-5.81l-8-11.07a17 17 0 0 1-3.17-9.92V1.25A1.25 1.25 0 0 0 67.97 0Zm-8.81 2.5h7.56v25.33a19.43 19.43 0 0 0 3.65 11.38l8 11.08a7.43 7.43 0 0 1 1.39 4.34v33.8a3.26 3.26 0 0 1-3.15 3.37H45.72a3.26 3.26 0 0 1-3.15-3.36V47.27a3.81 3.81 0 0 1 .22-1Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'LifePreserverVestIcon';

export default Icon;
